import { createSelector } from "reselect";
import { EMPTY_SOR } from "src/globalConsts";
import { getTemplateNotificationMessages } from "../../../../../../store/notifications/template/selectors";
import { getAllTemplateMetadataById } from "../../../../../../store/templateMetadata/selectors";
import { ExtendedTemplateMessage } from "./TemplateCardList";
import {
  getDetailTableRowURL,
  getTableRowLinks,
} from "../../../../../../utils/internalLinksParsing";

// eslint-disable-next-line import/prefer-default-export
export const getExtendedTemplateMessages = createSelector(
  getTemplateNotificationMessages,
  getAllTemplateMetadataById,
  (msgs, metadataDict): ExtendedTemplateMessage[] =>
    msgs.map((msg) => {
      const { overviewTemplateId, recordPrimaryKey } = msg;

      const metadata = metadataDict[overviewTemplateId];
      const { image = "", name, displayAs, detailId } = metadata ?? {};

      const templateName = displayAs || name || "";

      const sor = metadata?.defaultSearchQuery ?? EMPTY_SOR;

      const linkParam = {
        sor,
        templateId: detailId,
        rowKeyValue: recordPrimaryKey,
        overviewId: overviewTemplateId,
      };

      const linkState = {
        sor,
        fulltextQuery: "",
      };

      const { detailLink } = getTableRowLinks(linkParam, linkState);

      return { ...msg, icon: image, templateName, link: detailLink };
    })
);
